<template>
  <nav
    class="d-flex justify-content-space-between align-items-center p-0 navbar navbar-dark navbar-expand-lg"
    type="dark"
  >
    <div class="w-100 h-100 no-gutters row">
      <div class="d-flex d-md-none justify-content-md-start align-items-center col-md-4 col-lg-4 col-xl-2 col-3">
        <div
          :class="{ active: menuMobileHidden }"
          class="navbar__item navbar__menu justify-content-center flex-wrap"
          @click="toggleHiddenMobileMenu()"
        >
          <img class="navbar__menu__icon" src="@/assets/icons/menu/ico-menu.svg" />
          <div class="text-uppercase w-100">menu</div>
        </div>
      </div>
      <div class="d-none d-md-flex justify-content-md-start align-items-center col-md-6 col-lg-5 col-xl-4 col-8">
        <ProjectChanger />
      </div>
      <div class="col-xl-5 col-lg-4 col-md-2 col-6">
        <div
          v-if="customerId && projectId"
          class="py-0 px-2 d-flex text-decoration-none justify-content-center align-items-center navbar__item navbar-brand"
          href="#"
        >
          <RouterLink
            :to="{
              name: 'dashboard',
              params: {
                customerId: customerId,
                projectId: projectId
              }
            }"
            class="text-decoration-none"
          >
            <img class="navbar__logo" src="@/assets/logo.svg" />
          </RouterLink>
          <span v-if="env !== 'production'" class="ml-3">
            {{ env.toUpperCase() }}
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-stretch col-lg-3 col-md-4 col-3">
        <div class="navbar__select navbar__select--borders">
          <div
            :class="{ active: userMenuVisible }"
            class="navbar__select__item navbar__item userMenuOpener"
            @click="showDropdown('userMenuVisible')"
          >
            <span class="d-flex">
              <img class="navbar__icon d-flex d-md-none" src="@/assets/icons/menu/ico-user.svg" />
              <span v-if="customerStore.selectedCustomer" class="d-none d-md-flex">
                <span v-if="authStore.apiUser != null">
                  {{ authStore.apiUser.firstName }} {{ authStore.apiUser.lastName }}
                </span>
                <span v-else>{{ $t("neprihlasen") }}</span>
              </span>
            </span>
            <img class="navbar__select__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </div>
          <div
            v-if="userMenuVisible"
            v-click-outside="vcoConfig"
            class="navbar__select__options navbar__select__options--big"
          >
            <div class="navbar__select__option" @click="$router.push({ name: 'profile' })">
              <div class="icon">
                <img class="" src="@/assets/icons/menu/ico-user.svg" />
              </div>
              {{ $t("osobniUdaje") }}
            </div>
            <a :href="this.$t('linkHelpdesk')" class="navbar__select__option" target="_blank">
              <div class="icon">
                <img class="" src="@/assets/icons/menu/ico-help.svg" />
              </div>
              {{ $t("helpdeskTicket") }}
            </a>
            <div class="navbar__select__option" @click="onLogout">
              <div class="icon">
                <img class="" src="@/assets/icons/menu/ico-logout.svg" />
              </div>
              {{ $t("odhlasitSe") }}
            </div>
            <div class="navbar__select__option--lang">
              <LocaleSwitcher />
            </div>
            <div
              class="navbar__select__option navbar__select__option--gray justify-content-center text-primary"
              @click="$router.push({ name: 'faq' })"
            >
              <a>
                <u>{{ $t("neviteSiRady") }}</u>
              </a>
            </div>
            <div class="navbar__select__option navbar__select__option--gray justify-content-center flex-wrap">
              <p class="w-100 text-center mb-2">
                {{ $t("napovedaPanaRadio") }}
              </p>
              <Switcher :key="23" :text="true" :value="!configStore.isRadioHelpDisabled" @switch="switchRadio" />
            </div>
          </div>
        </div>
        <div class="navbar__question navbar__item d-none d-md-flex" @click="$router.push({ name: 'faq' })">
          <img src="@/assets/icons/menu/ico-questionmark.svg" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import LocaleSwitcher from "@/components/localeSwitcher"
import ProjectChanger from "@/components/project-changer/project-changer"
import Switcher from "@/components/switcher"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useConfigStore } from "@/store/modules/config"

export default {
  setup() {
    const authStore = useAuthStore()
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const configStore = useConfigStore()

    return {
      authStore,
      projectStore,
      customerStore,
      configStore
    }
  },
  directives: {},
  components: {
    LocaleSwitcher,
    ProjectChanger,
    Switcher
  },
  data() {
    return {
      logoTitle: process.env.VUE_APP_LOGO_TITLE,
      langs: ["cs", "en"],
      projectsVisible: false,
      userMenuVisible: false,
      loadedCustomer: {},
      loadedProjects: {},
      vcoConfig: {
        handler: this.hideUserMenu,
        middleware: this.middleware,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      }
    }
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV
    },
    projectId() {
      console.log(localStorage.getItem("selectedProject"))
      return this.$router.currentRoute.value.params.projectId
        ? this.$router.currentRoute.value.params.projectId
        : localStorage.getItem("selectedProject") && localStorage.getItem("selectedProject") != "null"
        ? JSON.parse(localStorage.getItem("selectedProject")).projectId
        : ""
    },
    customerId() {
      console.log(localStorage.getItem("selectedCustomer"))
      return this.$router.currentRoute.value.params.customerId
        ? this.$router.currentRoute.value.params.customerId
        : localStorage.getItem("selectedCustomer") && localStorage.getItem("selectedCustomer") != "null"
        ? JSON.parse(localStorage.getItem("selectedCustomer")).customerId
        : ""
    },
    lang() {
      return this.$i18n.lang
    },
    menuMobileHidden() {
      return this.$store.getters["menu/ifHideMobileMenu"]
    }
  },
  methods: {
    onLogout() {
      this.authStore.signOut()
    },
    showDropdown(menu) {
      this[menu] ? (this[menu] = false) : (this[menu] = true)
    },
    hideUserMenu() {
      this.userMenuVisible = false
    },
    middleware(event) {
      return event.target.className !== "userMenuOpener"
    },
    toggleHiddenMobileMenu() {
      if (this.menuMobileHidden) {
        this.$store.commit(
          "menu/setHiddenMobileMenu",
          {
            value: false
          },
          { root: true }
        )
      } else {
        this.$store.commit(
          "menu/setHiddenMobileMenu",
          {
            value: true
          },
          { root: true }
        )
      }
    },
    switchRadio() {
      this.configStore.setRadioHelp(this.configStore.isRadioHelpDisabled)
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  cursor: pointer;
}

a.router-link-active {
  color: white !important;
}
</style>
